import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faArrowUpFromLine } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import { useChecklistExpand } from 'src/models/bids/BidChecklist/hooks';

export const BidChecklistExpandButton: FC = () => {
  const { t } = useTranslation();
  const [isExpanded, toggleChecklist] = useChecklistExpand();

  const onClickHandler = useCallback(
    e => {
      e.preventDefault();
      toggleChecklist();
    },
    [toggleChecklist]
  );

  return (
    <button
      type="button"
      className={classNames(styles.checklistButton, { [styles.isHidden]: isExpanded })}
      onClick={onClickHandler}
    >
      <FontAwesomeIcon icon={faArrowUpFromLine} className={classNames(styles.icon, styles.arrowIcon)} />
      {t('Checklist.checklist')}
      <FontAwesomeIcon icon={faInfoCircle} className={classNames(styles.icon, styles.infoIcon)} />
    </button>
  );
};

export default BidChecklistExpandButton;
